export default class StringHelper {
    public static changeFirstLatterToUpperCase(string: string): string {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    public static removePolishDiacritics(string: string): string {
        return string
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\u0142/g, "l")
            .replace(/\u0141/g, "L");
    }
}
